import service from '../api/template.service';
//constants
const dataTemplate = {
    templates: [],
    createTemplate: '',
    errorTemplate: '',
    deleteTemplate: ''
}

//types
const TEMPLATE_LIST = 'TEMPLATE_LIST'
const TEMPLATE_UPDATE = 'TEMPLATE_UPDATE'
const TEMPLATE_DELETE = 'TEMPLATE_DELETE'
const TEMPLATE_ERROR = 'TEMPLATE_ERROR'

export default function templateReducer(state = dataTemplate, action) {
    switch (action.type) {
        case TEMPLATE_LIST:
            return { ...state, templates: action.payload };
        case TEMPLATE_UPDATE:
            return { ...state, createTemplate: action.payload };
        case TEMPLATE_DELETE:
            return { ...state, deleteTemplate: action.payload };
        case TEMPLATE_ERROR:
            return { ...state, errorTemplate: action.payload };
        default:
            return { ...state };
    }
}

export const getTemplates = () => async (dispatch) => {
    const response = await service.getTemplates().then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.code !== undefined) {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: response
        });
        dispatch({
            type: TEMPLATE_LIST,
            payload: []
        });

    } else {
        let data = [];
        response.forEach((element) => {
            data.push({
                value: element.id,
                label: element.name.toUpperCase(),
            });
        });

        dispatch({
            type: TEMPLATE_ERROR,
            payload: ''
        });
        dispatch({
            type: TEMPLATE_LIST,
            payload: data
        });
    }
}

export const createTemplate = (template, username) => async (dispatch) => {
    const response = await service.addTemplate(template, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: response
        });
        dispatch({
            type: TEMPLATE_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: ''
        });
        dispatch({
            type: TEMPLATE_UPDATE,
            payload: response
        });
    }
}

export const updateTemplate = (template, username) => async (dispatch) => {
    const response = await service.updateTemplate(template, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: response
        });
        dispatch({
            type: TEMPLATE_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: ''
        });
        dispatch({
            type: TEMPLATE_UPDATE,
            payload: response
        });
    }
}

export const deleteTemplate = (lsData, username) => async (dispatch) => {
    const response = await service.deleteTemplate(lsData, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.error !== undefined) {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: response
        });
        dispatch({
            type: TEMPLATE_DELETE,
            payload: []
        });
    } else {
        dispatch({
            type: TEMPLATE_ERROR,
            payload: ''
        });
        dispatch({
            type: TEMPLATE_DELETE,
            payload: response
        });
    }
}
